export default {
  name: "Назва",
  tel: "Телефон",
  save: "заощадити",
  confirm: "підтверджувати",
  cancel: "Скасувати",
  delete: "видаляти",
  complete: "Закінчити",
  loading: "Завантаження ...",
  telEmpty: "Будь ласка, заповніть свій номер телефону",
  nameEmpty: "Будь ласка, заповніть своє ім’я",
  nameInvalid: "Введіть дійсне ім’я",
  confirmDelete: "Ви впевнені, що хочете його видалити",
  telInvalid: "Введіть правильний номер телефону",
  vanCalendar: {
    end: "Закінчити",
    start: "почати",
    title: "титул",
    confirm: "підтверджувати",
    startEnd: "Почати кінець",
    weekdays: {
      "0": "день",
      "1": "один",
      "2": "два",
      "3": "три",
      "4": "Чотири",
      "5": "п'ять",
      "6": "шість"
    }
  },
  vanCascader: { select: "Будь ласка, виберіть" },
  vanContactCard: { addText: "Додати контакт" },
  vanContactList: { addText: "Нова контактна особа" },
  vanPagination: { prev: "Попередня сторінка", next: "Наступна сторінка" },
  vanPullRefresh: {
    pulling: "Потягнути, щоб оновити ...",
    loosing: "Відпустіть оновлення ..."
  },
  vanSubmitBar: { label: "ВСІ:" },
  vanCoupon: { unlimited: "Немає обмежень використання" },
  vanCouponCell: { title: "Купони", tips: "недоступний" },
  vanCouponList: {
    empty: "Немає купонів",
    exchange: "обмін",
    close: "Немає купонів",
    enable: "Доступний",
    disabled: "недоступний",
    placeholder: "Введіть код знижки"
  },
  vanAddressEdit: {
    area: "область",
    postal: "поштовий індекс",
    areaEmpty: "Виберіть регіон",
    addressEmpty: "Будь ласка, заповніть детальну адресу",
    postalEmpty: "Формат поштового індексу неправильний",
    defaultAddress: "Встановити як адресу доставки за замовчуванням",
    telPlaceholder: "Номер мобільного вихователя",
    namePlaceholder: "Ім'я вантажоодержувача",
    areaPlaceholder: "Виберіть провінцію/місто/район"
  },
  vanAddressEditDetail: {
    label: "адреса",
    placeholder:
      "Номер вуличних дверей, номер кімнати для підлоги та інша інформація"
  },
  vanAddressList: { add: "Додайте адресу" }
};
